import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[addminsffix]'
})
export class AddMinSffixDirective {

  constructor(private el: ElementRef) {
  }
  
  @HostListener('input', ['$event']) onInput(event: any) {
    let value = this.el.nativeElement.value;
    if(event.inputType === 'deleteContentBackward'){
      this.el.nativeElement.value = null;
      return;
    }
    
    if (!/^\d+$/.test(value)) {
      value = value.replace(/\D/g, '');
      this.el.nativeElement.value = value;
    }

    if (value.length > 5) {
      value = value.substring(0, 5);
      this.el.nativeElement.value = value;
    }
    
    if (value && !value.endsWith('min')) {
      this.el.nativeElement.value = value + ' min';
    }
    if(value === ''){
      this.el.nativeElement.value = null
    }


  }


}
